var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (!_vm.embed)?_c('button',{staticClass:"payButton checkout_btn btn btn-success",on:{"click":_vm.payWithPaystack}},[_vm._t("default",[_vm._v("Make Payment")])],2):_c('div',{attrs:{"id":"paystackEmbedContainer"}})}
var staticRenderFns = []

export { render, staticRenderFns }